import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import "./index.css";

import DateUtil from "./../../utils/Date";
import { isScopes } from "./../../services/Auth";
import { getDescriptionClient } from "./../../utils/Client";
import { getDescriptionPatrimony } from "./../../utils/Patrimony";

const LastDelayedLocationListItem = ({
  options: { id, onClick, delayedLocation, selected },
  props: { currentUser }
}) => {
  const { t } = useTranslation();
  return (
    <li className={`last-delayed-location-list-item ${selected ? "active" : ""}`} onClick={onClick}>
      <ul>
        <li>
          <div><span><strong>{getDescriptionClient(delayedLocation.patrimony.client)}</strong></span></div>
        </li>
        <li>
          <div><span><strong>{getDescriptionPatrimony(delayedLocation.patrimony)}</strong></span></div>
        </li>
        {
          [delayedLocation.tracker.serial].map((serial, index) => {
            const type = delayedLocation.patrimony.trackers.find(x => x.serial === serial);
            const chip = typeof type !== "undefined" ? (typeof type.chip !== "undefined" ? type.chip : false) : false;
            const trackerTypes = [
              { value: "HAT", label: t("Title.Hatch") },
              { value: "NIP", label: t("Title.Niple") },
              { value: "TRA", label: t("Title.Tracker") },
              { value: "TRA_NIP", label: `${t("Title.Tracker")}/${t("Title.Niple")}` }
            ];
            const selectedType = trackerTypes.find(x => x.value === type.type);
            if(type && (type.delayedLocation === false)) {
              return null;
            }
            return (
              <li className="niple-box" key={`lps-main-description-${index}`}>
                <ul>
                  <li className="niple-box-title">
                    <div>{selectedType ? selectedType.label : t("Title.Tracker")}:</div>
                  </li>
                  <li>
                    <div>{t("Title.Serial")}:</div>
                    <div><span>{serial}</span></div>
                  </li>
                  <li>
                    <div>{t("Title.Date")}:</div>
                    <div><span>{DateUtil.to({ date: new Date(delayedLocation.gps.date), format: "DD/MM/YYYY HH:mm:ss", tz: "America/Sao_Paulo"})}</span></div>
                  </li>
                  <li>
                    <div>{t("Title.Chip")}:</div>
                    <div><span>{chip ? type.chip.line : ""}</span></div>
                  </li>
                </ul>
              </li>
            );
          })
        }
        {
          isScopes({ currentUser, scopes: ["is:master", "read:patrimonies:description"], every: false }) && typeof delayedLocation.nipleNetwork !== "undefined" ? (
            delayedLocation.nipleNetwork.niples.map((niple, index) => {
              const type = delayedLocation.patrimony.trackers.find(x => x.serial === niple.serial);
              const chip = typeof type !== "undefined" ? (typeof type.chip !== "undefined" ? type.chip : false) : false;
              if(type && (type.delayedLocation === false || niple.serial === delayedLocation.tracker.serial)) {
                return null;
              }
              return (
                <li className="niple-box" key={`lps-niple-description-${index}`}>
                  <ul>
                    <li className="niple-box-title">
                      <div>{t("Title.Niple")}:</div>
                    </li>
                    <li>
                      <div>{t("Title.Niple.Serial")}:</div>
                      <div><span>{niple.serial}</span></div>
                    </li>
                    <li>
                      <div>{t("Title.Niple.Date")}:</div>
                      <div><span>{DateUtil.to({ date: new Date(niple.gps.date), format: "DD/MM/YYYY HH:mm:ss", tz: "America/Sao_Paulo"})}</span></div>
                    </li>
                    <li>
                      <div>{t("Title.Chip")}:</div>
                      <div><span>{chip ? type.chip.line : ""}</span></div>
                    </li>
                  </ul>
                </li>
              );
            })
          ) : null
        }
        {
          isScopes({ currentUser, scopes: ["is:master", "read:patrimonies:description"], every: false }) && typeof delayedLocation.nipleNetwork !== "undefined" ? (
            delayedLocation.nipleNetwork.hatchs.map((hatch, index) => {
              const type = delayedLocation.patrimony.trackers.find(x => x.serial === hatch.serial);
              const chip = typeof type !== "undefined" ? (typeof type.chip !== "undefined" ? type.chip : false) : false;
              if(type && (type.delayedLocation === false || hatch.serial === delayedLocation.tracker.serial)) {
                return null;
              }
              return (
                <li className="niple-box" key={`lps-hatch-description-${index}`}>
                  <ul>
                    <li className="niple-box-title">
                      <div>{t("Title.Hatch")}:</div>
                    </li>
                    <li>
                      <div>{t("Title.Hatch.Serial")}:</div>
                      <div><span>{hatch.serial}</span></div>
                    </li>
                    <li>
                      <div>{t("Title.Hatch.Date")}:</div>
                      <div><span>{DateUtil.to({ date: new Date(hatch.date), format: "DD/MM/YYYY HH:mm:ss", tz: "America/Sao_Paulo"})}</span></div>
                    </li>
                    <li>
                      <div>{t("Title.Chip")}:</div>
                      <div><span>{chip ? chip.line : ""}</span></div>
                    </li>
                  </ul>
                </li>
              );
            })
          ) : null
        }
        {
          isScopes({ currentUser, scopes: ["is:master", "read:patrimonies:description"], every: false }) && typeof delayedLocation.trackersBackup !== "undefined" ? (
          	 delayedLocation.trackersBackup.map((trackerBackup, index) => {
              const type = delayedLocation.patrimony.trackers.find(x => x.serial === trackerBackup.serial);
              const chip = typeof type !== "undefined" ? (typeof type.chip !== "undefined" ? type.chip : false) : false;
              if(type && (type.delayedLocation === false || trackerBackup.serial === delayedLocation.tracker.serial)) {
                return null;
              }
              return (
                <li className="niple-box" key={`lps-tracker-backup-description-${index}`}>
                  <ul>
                    <li className="niple-box-title">
                      <div>{t("Title.Tracker.Help")}:</div>
                    </li>
                    <li>
                      <div>{t("Title.Tracker.Help.Serial")}:</div>
                      <div><span>{trackerBackup.serial}</span></div>
                    </li>
                    <li>
                      <div>{t("Title.Tracker.Help.Date")}:</div>
                      <div><span>{DateUtil.to({ date: new Date(trackerBackup.date), format: "DD/MM/YYYY HH:mm:ss", tz: "America/Sao_Paulo"})}</span></div>
                    </li>
                    <li>
                      <div>{t("Title.Chip")}:</div>
                      <div><span>{chip ? chip.line : ""}</span></div>
                    </li>
                  </ul>
                </li>
              );
            })
          ) : null
        }
      </ul>
    </li>
  );
};

const mapStateToProps = state => ({
  props: {
    currentUser: state.users.currentUser
  }
});

const mapDispatchToProps = dispatch => ({
  funcs: bindActionCreators(Object.assign({}), dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LastDelayedLocationListItem);
